// extracted by mini-css-extract-plugin
export default {"oauth":"OauthButtons_oauth__ECFrK","oauth__fallback":"OauthButtons_oauth__fallback__1RyXx","oauth__status":"OauthButtons_oauth__status__no4oB"};